fx.ns("shared.components", class CoverThumbBackground extends shared.components.CoverThumb 
{    
    constructor(parameters)
    {
        super(parameters);
    }

    load()
    {
        super.load();


        if (this.model.creation.isBook && this.data.creation !== undefined && (this.data.creation == "slice" || this.data.creation != this.side))
            this.ready();
        else
        {
            var background = this.model.backgrounds.find({id : this.data.content});

            if (!background)
                this.drawColoredBackgroundOnCanvas(this.data);
            else
                this.loadImage(background.light_url);
        }
    }

    drawColoredBackgroundOnCanvas()
    {
        if (this.model.creation.isCalendar && this.data.creation == "top" && this.model.creation.cover_option == "wall-double")
            this.ready();    
        else
        {
            this.context.fillStyle=this.data.bgcolor;
            this.context.fillRect(0, 0, this.creationSize.width, this.creationSize.height);
            this.ready();
        }
    }

    onImageLoaded()
    {
        this.context.save();
        //if (this.model.creation.isBook && this.data.creation != "right")
        if (this.side == "right")
        {
            this.context.scale(-1,1);
            this.context.drawImage(this.image, 0, 0, -this.creationSize.width,  this.creationSize.height);  // TODO : there was coverHeight here
        }
        else
            this.context.drawImage(this.image, 0, 0, this.creationSize.width,  this.creationSize.height); // TODO : there was coverHeight here

        this.context.restore();
        this.ready();
    }
});